module.exports = __webpack_public_path__ + "static/img/nodata.06f07cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nodata.png
// module id = 5c/t
// module chunks = 1